document.addEventListener("DOMContentLoaded", function () {
    const trigger = document.getElementById("deal_calendar_button");
    const closeButton = document.getElementById("deal_calendar_close");
    const backToTopButton = document.getElementById("deal_calendar_back_to_top");
    const loadingEl = document.getElementById("deal_calendar_loading");
    const loadingPercentEl = document.getElementById("deal_calendar_loading_percent");
    const statusEl = document.getElementById("deal_calendar_status");
    const contentEl = document.getElementById("deal_calendar_content");
    const calendarEl = document.getElementById("deal_calendar_fullcalendar");
    const headerTitleEl = document.getElementById("deal_calendar_header_title");
    const cardBodyEl = document.querySelector("#kt_drawer_deal_calendar .card-body");

    if (!trigger || !closeButton || !backToTopButton || !loadingEl || !statusEl || !contentEl || !calendarEl || !headerTitleEl || !cardBodyEl || typeof FullCalendar === "undefined") {
        return;
    }

    const sectionsEl = document.getElementById("deal_calendar_sections");

    let dealCalendar = null;
    let dealCalendarData = null;
    let dealCalendarMergedData = null;
    let dealCalendarLoadedMonthKeys = new Set();
    let dealCalendarMonthFetchInProgress = false;
    let currentCalendarRange = null;
    let loadingProgressInterval = null;
    let loadingProgressTimeout = null;
    let loadingProgressValue = 0;
    let loadingStartedAt = 0;
    let dealCalendarRefreshTimer = null;
    let dealCalendarRefreshInFlight = false;
    let dealCalendarLoadRequest = null;
    let dealCalendarMonthRequest = null;
    const dealCalendarRefreshMs = 60000;

    function escapeHtml(value) {
        return String(value ?? "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }

    function renderEmptyState() {
        return '<div class="fs-7 text-gray-500 px-2 py-2">No events in this timeframe.</div>';
    }

    function formatDueText(event) {
        const absDays = Math.abs(Number(event.days_from_today || 0));

        if (event.is_overdue) {
            return "Overdue: " + escapeHtml(event.formatted_due_date) + " (" + absDays + " day" + (absDays === 1 ? "" : "s") + ")";
        }

        if (event.is_today) {
            return "Due: " + escapeHtml(event.formatted_due_date) + " (Today)";
        }

        const dayLabel = Number(event.days_from_today) === 1 ? "day" : "days";

        return "Due: " + escapeHtml(event.formatted_due_date) + " (" + escapeHtml(event.days_from_today) + " " + dayLabel + ")";
    }

    function renderAvatars(avatars) {
        if (!Array.isArray(avatars) || !avatars.length) {
            return "";
        }

        return avatars.map(function (avatar) {
            const name = escapeHtml(avatar.name);
            const initials = escapeHtml(avatar.initials);
            const color = escapeHtml(avatar.avatar_color || "#0E5DCB");
            const image = avatar.avatar_url
                ? '<img src="' + escapeHtml(avatar.avatar_url) + '" alt="' + name + '" onerror="this.remove(); this.parentNode.textContent=\'' + initials + '\';">'
                : initials;

            return '<span class="deal-calendar-avatar" title="' + name + '" style="background-color:' + color + ';">' + image + "</span>";
        }).join("");
    }

    function getCurrentDealId() {
        if (typeof window.deal_id === "number" || typeof window.deal_id === "string") {
            const scalarValue = String(window.deal_id).trim();

            if (/^\d+$/.test(scalarValue)) {
                return scalarValue;
            }
        }

        const dealInput = document.querySelector('input#deal_id[value], input[name="deal_id"][value]');
        if (!dealInput) {
            return null;
        }

        const inputValue = String(dealInput.value || "").trim();
        return /^\d+$/.test(inputValue) ? inputValue : null;
    }

    function getCurrentPortfolioId() {
        const portfolioInput = document.querySelector('input#portfolio_id[value], input[name="portfolio_id"][value]');
        if (!portfolioInput) {
            return null;
        }

        const inputValue = String(portfolioInput.value || "").trim();
        return /^\d+$/.test(inputValue) ? inputValue : null;
    }

    function getCurrentContextName() {
        if (typeof document.title === "string" && document.title.trim() !== "") {
            return document.title.trim();
        }

        const breadcrumbDealLink = document.querySelector(".dealbreadcrumbs + a");
        if (breadcrumbDealLink && breadcrumbDealLink.textContent.trim() !== "") {
            return breadcrumbDealLink.textContent.trim();
        }

        return "";
    }

    function renderContextLabel(event, currentDealId) {
        if (!event.context_label) {
            return "";
        }

        const eventDealId = event.deal_id ? String(event.deal_id) : null;

        if (eventDealId && currentDealId !== eventDealId) {
            return '<div class="deal-calendar-event-context fs-7 mt-1"><a href="/deals/view/id/' + escapeHtml(eventDealId) + '" class="deal-calendar-link">' + escapeHtml(event.context_label) + '</a></div>';
        }

        return '<div class="deal-calendar-event-context fs-7 mt-1">' + escapeHtml(event.context_label) + "</div>";
    }

    function renderCreatedBy(event) {
        if (event.created_by_contact_id && event.created_by_name) {
            return '<a href="#" class="deal-calendar-link" onclick="window.openDealCalendarContact(event, ' + escapeHtml(event.created_by_contact_id) + ')">' + escapeHtml(event.created_by_name) + "</a>";
        }

        return escapeHtml(event.created_by_name);
    }

    function renderSyncFlow(event) {
        if (!event.sync_provider || !event.sync_direction) {
            return "";
        }

        const providerName = event.sync_provider === "microsoft" ? "Outlook" : "Google Calendar";
        const providerLogo = event.sync_provider === "microsoft"
            ? "/demo2/media/svg/calendar-sync/outlook.svg?v=4"
            : "/demo2/media/logos/google-calendar.png?v=5";
        const provider = '<img class="calendar-sync-logo" src="' + providerLogo + '" alt="">';
        const cre = '<img class="calendar-sync-logo" src="/demo2/media/logos/CREPipeline-MobileApp-Icon.png" alt="">';
        const arrow = '<span class="calendar-sync-arrow" aria-hidden="true">' + (event.sync_direction === "inbound" ? "→" : "←") + "</span>";
        const flow = provider + arrow + cre;

        return '<span class="calendar-sync-flow" role="img" aria-label="' + escapeHtml(event.sync_label || providerName) + '" title="' + escapeHtml(event.sync_label || providerName) + '">' + flow + "</span>";
    }

    function renderEventCard(event, currentDealId) {
        const overdueClass = event.is_overdue ? " is-overdue" : "";
        const contextHtml = renderContextLabel(event, currentDealId);
        const avatarsHtml = renderAvatars(event.avatars);
        const statusHtml = renderStatusBadge(event);
        const syncFlowHtml = renderSyncFlow(event);

        return '' +
            '<div class="deal-calendar-event-card' + overdueClass + '">' +
                '<div class="d-flex gap-1">' +
                    '<div class="deal-calendar-event-date">' +
                        "<span>" + escapeHtml(event.month_label) + "</span>" +
                        "<strong>" + escapeHtml(event.day_label) + "</strong>" +
                    "</div>" +
                    '<div class="flex-grow-1">' +
                        '<div class="d-flex flex-wrap align-items-center gap-2 mb-1">' +
                        '<span class="badge badge-light deal-calendar-badge type-' + escapeHtml(event.type_key) + '">' + escapeHtml(event.type_label) + "</span>" +
                        statusHtml +
                        "</div>" +
                        syncFlowHtml +
                        '<div class="deal-calendar-event-title fs-7 fw-bolder">' + escapeHtml(event.title) + "</div>" +
                        contextHtml +
                        '<div class="deal-calendar-event-countdown d-flex gap-1 fs-8 mt-1 flex-wrap align-items-center">' +
                            '<div>' + formatDueText(event) + '</div>' +
                            '<div class="deal-calendar-event-created-by">| Created by ' + renderCreatedBy(event) + "</div>" +
                            '<div class="deal-calendar-avatar-group">' + avatarsHtml + "</div>" +
                        "</div>" +
                    "</div>" +
                "</div>" +
            "</div>";
    }

    function sanitizeStatusHexColor(color) {
        if (typeof color !== "string") {
            return null;
        }

        let value = color.trim();
        if (!value) {
            return null;
        }
        if (value.charAt(0) !== "#") {
            value = "#" + value;
        }

        const shortMatch = value.match(/^#([0-9A-Fa-f]{3})$/);
        if (shortMatch) {
            const hex = shortMatch[1];
            return "#" + hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }

        const longMatch = value.match(/^#([0-9A-Fa-f]{6})([0-9A-Fa-f]{2})?$/);
        if (longMatch) {
            return "#" + longMatch[1];
        }

        return null;
    }

    function renderStatusBadge(event) {
        if (!event || !event.status_name) {
            return "";
        }

        const bg = sanitizeStatusHexColor(event.status_color) || "#7e8299";
        const fg = sanitizeStatusHexColor(event.status_text_color) || "#FFFFFF";

        return '<span class="badge deal-calendar-status-badge" style="background-color:' + bg + ';color:' + fg + ';">'
            + escapeHtml(event.status_name)
            + "</span>";
    }

    function getSectionsForCurrentMonth() {
        const sections = Array.isArray(dealCalendarData && dealCalendarData.sections) ? dealCalendarData.sections : [];

        if (!currentCalendarRange || !currentCalendarRange.start || !currentCalendarRange.end) {
            return sections;
        }

        const startDate = getLocalDateKey(currentCalendarRange.start);
        const endDate = getLocalDateKey(new Date(currentCalendarRange.end.getTime() - 1));
        const startMonthKey = startDate.slice(0, 7);

        return sections.filter(function (section) {
            return section.date_key >= startDate &&
                section.date_key <= endDate &&
                section.date_key.slice(0, 7) === startMonthKey;
        });
    }

    function renderSections() {
        const sections = getSectionsForCurrentMonth();

        if (!sectionsEl) {
            return;
        }

        if (!sections.length) {
            sectionsEl.innerHTML = renderEmptyState();
            return;
        }

        const currentDealId = getCurrentDealId();

        sectionsEl.innerHTML = sections.map(function (section) {
            const events = Array.isArray(section.events) ? section.events : [];

            return '' +
                '<div class="deal-calendar-section-group mb-6" data-date-key="' + escapeHtml(section.date_key) + '">' +
                    '<div class="deal-calendar-section-header d-flex justify-content-between align-items-center mb-3">' +
                        '<h3 class="deal-calendar-section-title fs-6 fw-bolder mb-0">' + escapeHtml(section.label) + '</h3>' +
                        '<span class="timeframe-count fs-7 fw-semibold">(' + String(events.length) + ') result(s) </span>' +
                    '</div>' +
                    '<div class="deal-calendar-event-list">' +
                        (events.length ? events.map(function (event) { return renderEventCard(event, currentDealId); }).join("") : renderEmptyState()) +
                    '</div>' +
                '</div>';
        }).join("");
    }

    function scrollToSection(dateKey) {
        if (!sectionsEl || !dateKey) {
            return;
        }

        const targetSection = sectionsEl.querySelector('[data-date-key="' + dateKey + '"]');

        if (!targetSection) {
            return;
        }

        targetSection.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    }

    function getLocalDateKey(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return year + "-" + month + "-" + day;
    }

    function pad2(n) {
        return String(n).padStart(2, "0");
    }

    function monthKeyFromDate(d) {
        return d.getFullYear() + "-" + pad2(d.getMonth() + 1);
    }

    function formatLocalYmd(d) {
        return d.getFullYear() + "-" + pad2(d.getMonth() + 1) + "-" + pad2(d.getDate());
    }

    function startOfMonthFromKey(monthKey) {
        const parts = monthKey.split("-");
        const y = parseInt(parts[0], 10);
        const m = parseInt(parts[1], 10) - 1;
        return new Date(y, m, 1);
    }

    function getInitialThreeMonthRange() {
        const today = new Date();
        const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const end = new Date(today.getFullYear(), today.getMonth() + 2, 1);
        return { start: start, end: end };
    }

    /**
     * For each missing month, include that month plus the previous and next calendar month (3-month band).
     * When several months are missing, use one range that covers the union of those bands.
     */
    function getExpandedThreeMonthFetchRange(firstMissingMonthKey, lastMissingMonthKey) {
        const firstAnchor = startOfMonthFromKey(firstMissingMonthKey);
        const lastAnchor = startOfMonthFromKey(lastMissingMonthKey);
        const rangeStart = new Date(firstAnchor.getFullYear(), firstAnchor.getMonth() - 1, 1);
        const rangeEnd = new Date(lastAnchor.getFullYear(), lastAnchor.getMonth() + 2, 1);
        return { start: rangeStart, end: rangeEnd };
    }

    function markMonthsLoaded(rangeStart, rangeEndExclusive) {
        let d = new Date(rangeStart.getFullYear(), rangeStart.getMonth(), 1);
        while (d.getTime() < rangeEndExclusive.getTime()) {
            dealCalendarLoadedMonthKeys.add(monthKeyFromDate(d));
            d = new Date(d.getFullYear(), d.getMonth() + 1, 1);
        }
    }

    function monthsOverlappingRange(rangeStart, rangeEndExclusive) {
        const keys = [];
        let d = new Date(rangeStart.getFullYear(), rangeStart.getMonth(), 1);
        const limit = rangeEndExclusive.getTime();
        while (d.getTime() < limit) {
            keys.push(monthKeyFromDate(d));
            d = new Date(d.getFullYear(), d.getMonth() + 1, 1);
        }
        return keys;
    }

    function dealCalendarStableEventKey(ev) {
        if (!ev) {
            return "__null";
        }
        if (ev.id != null && String(ev.id).trim() !== "") {
            return String(ev.id).trim();
        }
        const whenRaw = ev.event_date || ev.start || "";
        const when = typeof whenRaw === "string" ? whenRaw.slice(0, 10) : "";
        return [
            "fb",
            ev.type_key || "",
            String(ev.title || ""),
            when,
            String(ev.deal_id || ""),
        ].join("|");
    }

    function dealCalendarEventSortDate(ev) {
        if (ev.event_date) {
            return String(ev.event_date);
        }
        if (ev.start) {
            return String(ev.start).slice(0, 10);
        }
        return "";
    }

    function dealCalendarSectionLabelFromDateKey(dateKey) {
        const parts = String(dateKey).split("-");
        if (parts.length !== 3) {
            return dateKey;
        }
        const d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
        if (isNaN(d.getTime())) {
            return dateKey;
        }
        return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
    }

    function collectSectionEventsIntoMap(sections, intoMap) {
        (sections || []).forEach(function (sec) {
            (sec.events || []).forEach(function (ev) {
                intoMap.set(dealCalendarStableEventKey(ev), ev);
            });
        });
    }

    function rebuildDealCalendarPayloadFromEventMap(dealName, eventByKey) {
        const all = Array.from(eventByKey.values());
        all.sort(function (a, b) {
            const da = dealCalendarEventSortDate(a);
            const db = dealCalendarEventSortDate(b);
            if (da !== db) {
                return da.localeCompare(db);
            }
            return dealCalendarStableEventKey(a).localeCompare(dealCalendarStableEventKey(b));
        });

        const byDate = new Map();
        all.forEach(function (ev) {
            const dk = dealCalendarEventSortDate(ev);
            if (!dk) {
                return;
            }
            if (!byDate.has(dk)) {
                byDate.set(dk, []);
            }
            byDate.get(dk).push(ev);
        });

        const sections = Array.from(byDate.keys()).sort().map(function (dk) {
            const events = byDate.get(dk).slice().sort(function (a, b) {
                return String(a.title || "").localeCompare(String(b.title || ""));
            });
            return {
                date_key: dk,
                label: dealCalendarSectionLabelFromDateKey(dk),
                events: events,
            };
        });

        const calendar_events = all.map(function (ev) {
            return {
                id: ev.id,
                title: ev.title,
                start: dealCalendarEventSortDate(ev),
                allDay: true,
            };
        });

        const calendar_event_dates = Array.from(byDate.keys()).sort();

        return {
            deal_name: dealName || "",
            calendar_events: calendar_events,
            calendar_event_dates: calendar_event_dates,
            sections: sections,
        };
    }

    function replaceDealCalendarRange(existing, incoming, rangeStart, rangeEnd) {
        const startKey = formatLocalYmd(rangeStart);
        const endKey = formatLocalYmd(rangeEnd);
        const map = new Map();
        collectSectionEventsIntoMap(existing && existing.sections, map);
        Array.from(map.entries()).forEach(function (entry) {
            const dateKey = dealCalendarEventSortDate(entry[1]).slice(0, 10);
            if (dateKey >= startKey && dateKey < endKey) {
                map.delete(entry[0]);
            }
        });
        collectSectionEventsIntoMap(incoming && incoming.sections, map);

        return rebuildDealCalendarPayloadFromEventMap(
            (incoming && incoming.deal_name) || (existing && existing.deal_name),
            map
        );
    }

    function loadedDealCalendarRange() {
        if (!dealCalendarLoadedMonthKeys.size) {
            return null;
        }

        const keys = Array.from(dealCalendarLoadedMonthKeys).sort();
        const start = startOfMonthFromKey(keys[0]);
        const last = startOfMonthFromKey(keys[keys.length - 1]);

        return {
            start: start,
            end: new Date(last.getFullYear(), last.getMonth() + 1, 1),
        };
    }

    function mergeDealCalendarPayload(existing, incoming) {
        if (!incoming) {
            return existing;
        }
        if (!existing) {
            return incoming;
        }
        const map = new Map();
        collectSectionEventsIntoMap(existing.sections, map);
        collectSectionEventsIntoMap(incoming.sections, map);
        return rebuildDealCalendarPayloadFromEventMap(incoming.deal_name || existing.deal_name, map);
    }

    function paintDealCalendarEvents(data) {
        dealCalendarData = data;

        if (!dealCalendar) {
            return;
        }

        // addEvent() re-renders the whole calendar per call, which freezes the page for large tenants.
        dealCalendar.batchRendering(function () {
            dealCalendar.removeAllEventSources();
            dealCalendar.addEventSource(data.calendar_events || []);
        });

        updateCalendarDayMarkers();
        renderSections();
    }

    /**
     * FullCalendar measures the grid while hidden (e.g. loading overlay); restore layout after #deal_calendar_content is visible.
     */
    function settleDealCalendarLayout() {
        if (!dealCalendar) {
            return;
        }
        requestAnimationFrame(function () {
            dealCalendar.updateSize();
            requestAnimationFrame(function () {
                dealCalendar.updateSize();
            });
        });
    }

    function updateCalendarDayMarkers() {
        const dateSet = new Set((dealCalendarData && dealCalendarData.calendar_event_dates) ? dealCalendarData.calendar_event_dates : []);
        const today = getLocalDateKey(new Date());

        calendarEl.querySelectorAll("td[data-date]").forEach(function (cell) {
            const cellDate = cell.getAttribute("data-date");
            const hasEvents = dateSet.has(cellDate);

            cell.classList.toggle("deal-calendar-has-events", hasEvents);
            cell.classList.toggle("deal-calendar-today", cellDate === today);
            cell.classList.toggle("deal-calendar-clickable", hasEvents);
        });
    }

    function loadMissingDealCalendarMonths() {
        if (!dealCalendar || !dealCalendarMergedData || dealCalendarMonthFetchInProgress) {
            return;
        }

        const viewStart = new Date(dealCalendar.view.currentStart);
        const viewEnd = new Date(dealCalendar.view.currentEnd);
        const monthsNeeded = monthsOverlappingRange(viewStart, viewEnd);
        const missing = monthsNeeded.filter(function (m) {
            return !dealCalendarLoadedMonthKeys.has(m);
        });

        if (!missing.length) {
            return;
        }

        missing.sort();
        const expandedRange = getExpandedThreeMonthFetchRange(missing[0], missing[missing.length - 1]);
        const rangeStart = expandedRange.start;
        const rangeEnd = expandedRange.end;

        const currentDealId = getCurrentDealId();
        const currentPortfolioId = getCurrentPortfolioId();
        let url = "/calendar/deals";

        if (currentDealId) {
            url = "/deals/" + currentDealId + "/calendar";
        } else if (currentPortfolioId) {
            url = "/portfolios/" + currentPortfolioId + "/calendar";
        }

        dealCalendarMonthFetchInProgress = true;
        setLoadingState(true);

        const request = $.ajax({
            url: url,
            method: "GET",
            data: {
                start: formatLocalYmd(rangeStart),
                end: formatLocalYmd(rangeEnd),
            },
            success: function (incoming) {
                if (request !== dealCalendarMonthRequest) {
                    return;
                }
                dealCalendarMonthRequest = null;

                finishLoadingProgress(function () {
                    dealCalendarMergedData = mergeDealCalendarPayload(dealCalendarMergedData, incoming);
                    markMonthsLoaded(rangeStart, rangeEnd);
                    setLoadingState(false);
                    setStatus("", false);
                    paintDealCalendarEvents(dealCalendarMergedData);
                    settleDealCalendarLayout();
                    dealCalendarMonthFetchInProgress = false;
                });
            },
            error: function () {
                if (request !== dealCalendarMonthRequest) {
                    return;
                }
                dealCalendarMonthRequest = null;

                finishLoadingProgress(function () {
                    setLoadingState(false);
                    setStatus("Unable to load calendar data for that month right now.", true);
                    settleDealCalendarLayout();
                    dealCalendarMonthFetchInProgress = false;
                });
            },
        });
        dealCalendarMonthRequest = request;
    }

    function renderCalendar(data) {
        dealCalendarData = data;

        if (!dealCalendar) {
            dealCalendar = new FullCalendar.Calendar(calendarEl, {
                initialView: "dayGridMonth",
                headerToolbar: {
                    left: "prevYear prev",
                    center: "title",
                    right: "next nextYear",
                },
                fixedWeekCount: false,
                showNonCurrentDates: false,
                dayHeaderFormat: { weekday: "short" },
                eventDisplay: "none",
                height: "auto",
                dayCellContent: function (info) {
                    return {
                        html: '' +
                            '<div class="deal-calendar-day-shell">' +
                                '<span class="deal-calendar-day-number">' + info.date.getDate() + "</span>" +
                                '<span class="deal-calendar-day-dot"></span>' +
                            "</div>",
                    };
                },
                datesSet: function () {
                    currentCalendarRange = {
                        start: new Date(dealCalendar.view.currentStart),
                        end: new Date(dealCalendar.view.currentEnd),
                    };

                    updateCalendarDayMarkers();
                    renderSections();
                    loadMissingDealCalendarMonths();
                },
                dateClick: function (info) {
                    const dateKey = getLocalDateKey(info.date);
                    const dateSet = new Set((dealCalendarData && dealCalendarData.calendar_event_dates) ? dealCalendarData.calendar_event_dates : []);

                    if (!dateSet.has(dateKey)) {
                        return;
                    }

                    scrollToSection(dateKey);
                },
            });

            dealCalendar.render();
        }

        paintDealCalendarEvents(data);
    }

    function setLoadingState(isLoading) {
        if (loadingProgressTimeout) {
            clearTimeout(loadingProgressTimeout);
            loadingProgressTimeout = null;
        }

        loadingEl.classList.toggle("d-none", !isLoading);
        contentEl.classList.toggle("d-none", isLoading);
        if (isLoading) {
            startLoadingProgress();
            statusEl.classList.add("d-none");
            statusEl.textContent = "";
        }
    }

    function updateLoadingProgress(value) {
        loadingProgressValue = Math.max(0, Math.min(100, value));

        if (loadingPercentEl) {
            loadingPercentEl.textContent = Math.round(loadingProgressValue) + "%";
        }
    }

    function startLoadingProgress() {
        if (loadingProgressInterval) {
            clearInterval(loadingProgressInterval);
        }

        loadingStartedAt = Date.now();
        updateLoadingProgress(10);

        loadingProgressInterval = setInterval(function () {
            if (loadingProgressValue >= 95) {
                return;
            }

            const increment = loadingProgressValue < 70
                ? Math.random() * 10 + 5
                : Math.random() * 3 + 1;

            updateLoadingProgress(Math.min(95, loadingProgressValue + increment));
        }, 120);
    }

    function finishLoadingProgress(callback) {
        if (loadingProgressInterval) {
            clearInterval(loadingProgressInterval);
            loadingProgressInterval = null;
        }

        const elapsed = Date.now() - loadingStartedAt;
        const minimumVisibleDuration = 500;
        const remainingDelay = Math.max(0, minimumVisibleDuration - elapsed);

        loadingProgressTimeout = setTimeout(function () {
            updateLoadingProgress(100);

            loadingProgressTimeout = setTimeout(function () {
                loadingProgressTimeout = null;
                callback();
            }, 120);
        }, remainingDelay);
    }

    function setStatus(message, isError) {
        statusEl.textContent = message;
        statusEl.classList.toggle("d-none", !message);
        statusEl.classList.toggle("text-danger", !!isError);
        statusEl.classList.toggle("text-gray-500", !isError);
    }

    function setHeaderTitle(dealName) {
        const trimmedName = String(dealName || "").trim();
        headerTitleEl.textContent = trimmedName ? "Deal Calendar - " + trimmedName : "Deal Calendar";
    }

    function updateBackToTopVisibility() {
        backToTopButton.classList.toggle("is-visible", cardBodyEl.scrollTop > 500);
    }

    function loadDealCalendar() {
        cancelDealCalendarRequests();
        setLoadingState(true);

        dealCalendarLoadedMonthKeys.clear();
        dealCalendarMergedData = null;

        const currentDealId = getCurrentDealId();
        const currentPortfolioId = getCurrentPortfolioId();
        const currentContextName = currentDealId || currentPortfolioId ? getCurrentContextName() : "";
        let url = "/calendar/deals";

        if (currentDealId) {
            url = "/deals/" + currentDealId + "/calendar";
        } else if (currentPortfolioId) {
            url = "/portfolios/" + currentPortfolioId + "/calendar";
        }

        setHeaderTitle(currentContextName);

        const initialRange = getInitialThreeMonthRange();

        const request = $.ajax({
            url: url,
            method: "GET",
            data: {
                start: formatLocalYmd(initialRange.start),
                end: formatLocalYmd(initialRange.end),
            },
            success: function (data) {
                if (request !== dealCalendarLoadRequest) {
                    return;
                }
                dealCalendarLoadRequest = null;

                finishLoadingProgress(function () {
                    setLoadingState(false);
                    setStatus("", false);
                    setHeaderTitle(data.deal_name || currentContextName);

                    dealCalendarMergedData = data;
                    markMonthsLoaded(initialRange.start, initialRange.end);

                    requestAnimationFrame(function () {
                        renderCalendar(dealCalendarMergedData);
                        settleDealCalendarLayout();
                    });
                });
            },
            error: function () {
                if (request !== dealCalendarLoadRequest) {
                    return;
                }
                dealCalendarLoadRequest = null;

                finishLoadingProgress(function () {
                    setLoadingState(false);
                    setHeaderTitle("");
                    setStatus("Unable to load calendar data right now.", true);
                });
            },
        });
        dealCalendarLoadRequest = request;
    }

    function cancelDealCalendarRequests() {
        const pending = [dealCalendarLoadRequest, dealCalendarMonthRequest];
        dealCalendarLoadRequest = null;
        dealCalendarMonthRequest = null;
        dealCalendarMonthFetchInProgress = false;

        pending.forEach(function (request) {
            if (request) {
                request.abort();
            }
        });

        if (loadingProgressInterval) {
            clearInterval(loadingProgressInterval);
            loadingProgressInterval = null;
        }
        if (loadingProgressTimeout) {
            clearTimeout(loadingProgressTimeout);
            loadingProgressTimeout = null;
        }
    }

    window.openDealCalendarContact = function (event, contactId) {
        if (event) {
            event.preventDefault();
        }

        if (typeof KTDrawer !== "undefined") {
            const drawer = KTDrawer.getInstance(document.getElementById("kt_drawer_deal_calendar"));
            if (drawer) {
                drawer.hide();
            }
        }

        if (typeof window.viewContact === "function") {
            window.viewContact(new Event("click"), contactId);
        }
    };

    function dealCalendarDrawerIsOpen() {
        const drawer = document.getElementById("kt_drawer_deal_calendar");

        return !document.hidden && drawer && drawer.classList.contains("drawer-on");
    }

    function refreshDealCalendar() {
        if (dealCalendarRefreshInFlight || dealCalendarMonthFetchInProgress || !dealCalendarMergedData || !dealCalendarDrawerIsOpen()) {
            return;
        }

        const range = loadedDealCalendarRange();
        if (!range) {
            return;
        }

        const currentDealId = getCurrentDealId();
        const currentPortfolioId = getCurrentPortfolioId();
        let url = "/calendar/deals";

        if (currentDealId) {
            url = "/deals/" + currentDealId + "/calendar";
        } else if (currentPortfolioId) {
            url = "/portfolios/" + currentPortfolioId + "/calendar";
        }

        dealCalendarRefreshInFlight = true;
        const scrollTop = cardBodyEl.scrollTop;

        $.ajax({
            url: url,
            method: "GET",
            data: {
                start: formatLocalYmd(range.start),
                end: formatLocalYmd(range.end),
            },
            success: function (incoming) {
                if (!dealCalendarDrawerIsOpen() || !dealCalendarMergedData) {
                    return;
                }

                dealCalendarMergedData = replaceDealCalendarRange(dealCalendarMergedData, incoming, range.start, range.end);
                paintDealCalendarEvents(dealCalendarMergedData);
                cardBodyEl.scrollTop = scrollTop;
            },
            complete: function () {
                dealCalendarRefreshInFlight = false;
            },
        });
    }

    function stopDealCalendarRefresh() {
        if (!dealCalendarRefreshTimer) {
            return;
        }

        window.clearInterval(dealCalendarRefreshTimer);
        dealCalendarRefreshTimer = null;
    }

    function startDealCalendarRefresh() {
        if (dealCalendarRefreshTimer || !dealCalendarDrawerIsOpen()) {
            return;
        }

        dealCalendarRefreshTimer = window.setInterval(refreshDealCalendar, dealCalendarRefreshMs);
    }

    // KTDrawer events are not DOM events and allow one handler per element, so watch drawer-on instead.
    const dealCalendarDrawerEl = document.getElementById("kt_drawer_deal_calendar");
    let dealCalendarDrawerWasOpen = dealCalendarDrawerEl.classList.contains("drawer-on");
    new MutationObserver(function () {
        const isOpen = dealCalendarDrawerEl.classList.contains("drawer-on");
        if (isOpen === dealCalendarDrawerWasOpen) {
            return;
        }
        dealCalendarDrawerWasOpen = isOpen;

        if (isOpen) {
            loadDealCalendar();
            startDealCalendarRefresh();
            return;
        }

        cancelDealCalendarRequests();
        stopDealCalendarRefresh();
    }).observe(dealCalendarDrawerEl, {
        attributes: true,
        attributeFilter: ["class"],
    });

    document.addEventListener("visibilitychange", function () {
        if (dealCalendarDrawerIsOpen()) {
            refreshDealCalendar();
            startDealCalendarRefresh();
            return;
        }

        stopDealCalendarRefresh();
    });

    closeButton.addEventListener("click", function (event) {
        event.preventDefault();

        if (typeof KTDrawer === "undefined") {
            return;
        }

        const drawer = KTDrawer.getInstance(document.getElementById("kt_drawer_deal_calendar"));
        if (drawer) {
            drawer.hide();
        }

        window.App?.drawers?.sweepOverlays?.();
    });

    backToTopButton.addEventListener("click", function () {
        cardBodyEl.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    });

    cardBodyEl.addEventListener("scroll", updateBackToTopVisibility);
    updateBackToTopVisibility();
});
